// extracted by mini-css-extract-plugin
export default {"waiting-room-mute-button-muted":"App_waiting-room-mute-button-muted__G+80q","anticon":"App_anticon__7CG9H","app":"App_app__Skedh"};